@file:OptIn(InternalResourceApi::class)

package kpt.core.base.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/kpt.core.base.ui.generated.resources/"

@delegate:ResourceContentHash(-237_761_034)
public val Res.string.dashboard_freshness_loading: StringResource by lazy {
      StringResource("string:dashboard_freshness_loading", "dashboard_freshness_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 10, 71),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 10, 83),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 10, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10, 59),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 10, 47),
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), RegionQualifier("BR"), ), "${MD}values-pt-rBR/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 10, 63),
        ResourceItem(setOf(LanguageQualifier("th"), ), "${MD}values-th/strings.commonMain.cvr", 10, 75),
        ResourceItem(setOf(LanguageQualifier("tr"), ), "${MD}values-tr/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 10, 71),
        ResourceItem(setOf(LanguageQualifier("vi"), ), "${MD}values-vi/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 10, 51),
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("TW"), ), "${MD}values-zh-rTW/strings.commonMain.cvr", 10, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 51),
      ))
    }

@delegate:ResourceContentHash(-205_213_314)
public val Res.string.dashboard_freshness_updated: StringResource by lazy {
      StringResource("string:dashboard_freshness_updated", "dashboard_freshness_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 201, 67),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 169, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 157, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 161, 59),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 281, 103),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 149, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 161, 55),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 157, 55),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 185, 63),
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 149, 55),
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 165, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), RegionQualifier("BR"), ), "${MD}values-pt-rBR/strings.commonMain.cvr", 157, 55),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 189, 67),
        ResourceItem(setOf(LanguageQualifier("th"), ), "${MD}values-th/strings.commonMain.cvr", 237, 87),
        ResourceItem(setOf(LanguageQualifier("tr"), ), "${MD}values-tr/strings.commonMain.cvr", 161, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 193, 63),
        ResourceItem(setOf(LanguageQualifier("vi"), ), "${MD}values-vi/strings.commonMain.cvr", 173, 67),
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 153, 55),
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("TW"), ), "${MD}values-zh-rTW/strings.commonMain.cvr", 157, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149, 51),
      ))
    }

@delegate:ResourceContentHash(-1_140_674_516)
public val Res.string.dashboard_freshness_updated_refreshing: StringResource by lazy {
      StringResource("string:dashboard_freshness_updated_refreshing", "dashboard_freshness_updated_refreshing", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 82, 118),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 62, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66, 94),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 94, 186),
        ResourceItem(setOf(LanguageQualifier("id"), ), "${MD}values-id/strings.commonMain.cvr", 58, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66, 94),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 70, 86),
        ResourceItem(setOf(LanguageQualifier("ko"), ), "${MD}values-ko/strings.commonMain.cvr", 74, 110),
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 58, 90),
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 66, 98),
        ResourceItem(setOf(LanguageQualifier("pt"), RegionQualifier("BR"), ), "${MD}values-pt-rBR/strings.commonMain.cvr", 66, 90),
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 74, 114),
        ResourceItem(setOf(LanguageQualifier("th"), ), "${MD}values-th/strings.commonMain.cvr", 86, 150),
        ResourceItem(setOf(LanguageQualifier("tr"), ), "${MD}values-tr/strings.commonMain.cvr", 66, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82, 110),
        ResourceItem(setOf(LanguageQualifier("vi"), ), "${MD}values-vi/strings.commonMain.cvr", 66, 106),
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 62, 90),
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("TW"), ), "${MD}values-zh-rTW/strings.commonMain.cvr", 62, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62, 86),
      ))
    }

@delegate:ResourceContentHash(1_785_959_478)
public val Res.string.draft_discard: StringResource by lazy {
      StringResource("string:draft_discard", "draft_discard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201, 33),
      ))
    }

@delegate:ResourceContentHash(1_068_730_426)
public val Res.string.draft_failed: StringResource by lazy {
      StringResource("string:draft_failed", "draft_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235, 88),
      ))
    }

@delegate:ResourceContentHash(-1_390_764_693)
public val Res.string.draft_pending: StringResource by lazy {
      StringResource("string:draft_pending", "draft_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 324, 109),
      ))
    }

@delegate:ResourceContentHash(-1_653_482_582)
public val Res.string.draft_resume: StringResource by lazy {
      StringResource("string:draft_resume", "draft_resume", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 434, 28),
      ))
    }

@delegate:ResourceContentHash(-1_577_399_243)
public val Res.string.draft_save: StringResource by lazy {
      StringResource("string:draft_save", "draft_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 767, 38),
      ))
    }

@delegate:ResourceContentHash(858_867_244)
public val Res.string.draft_saved: StringResource by lazy {
      StringResource("string:draft_saved", "draft_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 659, 107),
      ))
    }

@delegate:ResourceContentHash(2_036_813_112)
public val Res.string.draft_saved_offline: StringResource by lazy {
      StringResource("string:draft_saved_offline", "draft_saved_offline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 463, 195),
      ))
    }

@delegate:ResourceContentHash(-7_673_461)
public val Res.string.draft_unsaved: StringResource by lazy {
      StringResource("string:draft_unsaved", "draft_unsaved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 806, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("dashboard_freshness_loading", Res.string.dashboard_freshness_loading)
  map.put("dashboard_freshness_updated", Res.string.dashboard_freshness_updated)
  map.put("dashboard_freshness_updated_refreshing", Res.string.dashboard_freshness_updated_refreshing)
  map.put("draft_discard", Res.string.draft_discard)
  map.put("draft_failed", Res.string.draft_failed)
  map.put("draft_pending", Res.string.draft_pending)
  map.put("draft_resume", Res.string.draft_resume)
  map.put("draft_save", Res.string.draft_save)
  map.put("draft_saved", Res.string.draft_saved)
  map.put("draft_saved_offline", Res.string.draft_saved_offline)
  map.put("draft_unsaved", Res.string.draft_unsaved)
}
